var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHandDollar(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "save-money",
    width: 34.728,
    height: 39.417,
    viewBox: "0 0 34.728 39.417",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    id: "Path_1902",
    d: "M188.853 156.632a.616.616 0 0 0-.222-.008 1.47 1.47 0 0 1-1.3-1.458.647.647 0 1 0-1.293 0 2.766 2.766 0 0 0 2.034 2.663v.647a.647.647 0 0 0 1.293 0v-.607a2.761 2.761 0 0 0-.566-5.463 1.468 1.468 0 1 1 1.468-1.468.647.647 0 0 0 1.293 0 2.766 2.766 0 0 0-2.2-2.7v-.588a.647.647 0 0 0-1.293 0v.628a2.761 2.761 0 0 0 .727 5.424 1.467 1.467 0 0 1 .054 2.933zm0 0",
    className: "cls-1",
    transform: "translate(-171.032 -135.119)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    id: "Path_1903",
    d: "M104.2 115.868a9.376 9.376 0 1 0 9.376-9.376 9.376 9.376 0 0 0-9.376 9.376zm9.376-8.083a8.083 8.083 0 1 1-8.083 8.083 8.082 8.082 0 0 1 8.078-8.083zm0 0",
    className: "cls-1",
    transform: "translate(-95.803 -97.885)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    id: "Path_1904",
    d: "M30.691 328.932l-5.065 2.393a4.125 4.125 0 0 0-3.517-2.17l-4.676-.128a4.938 4.938 0 0 1-2.125-.549l-.476-.247a8.392 8.392 0 0 0-7.773.008l.03-1.078a.647.647 0 0 0-.629-.664l-5.127-.141a.646.646 0 0 0-.664.629L.36 338.236a.647.647 0 0 0 .629.664l5.127.141h.018a.647.647 0 0 0 .647-.629l.015-.538 1.332-.713a2.285 2.285 0 0 1 1.705-.187l7.954 2.232.042.01a8.514 8.514 0 0 0 1.748.18 8.627 8.627 0 0 0 3.6-.786.6.6 0 0 0 .08-.044l11.532-7.459a.647.647 0 0 0 .212-.861 3.266 3.266 0 0 0-4.31-1.314zm-29.02 8.693l.274-9.959 3.834.105-.274 9.959zm20.926-.169a7.331 7.331 0 0 1-4.483.5l-7.932-2.227a3.575 3.575 0 0 0-2.665.291l-.681.365.182-6.621a7.107 7.107 0 0 1 7.22-.385l.476.247a6.245 6.245 0 0 0 2.684.693l4.676.128a2.836 2.836 0 0 1 2.7 2.26l-6.965-.192a.647.647 0 1 0-.036 1.293l7.686.212h.018a.647.647 0 0 0 .646-.629 4.1 4.1 0 0 0-.063-.839l5.195-2.455.015-.007a1.975 1.975 0 0 1 2.234.313zm0 0",
    className: "cls-1",
    transform: "translate(-.36 -299.98)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    id: "Path_1905",
    d: "M213.5 6.789V.647a.647.647 0 0 0-1.293 0v6.142a.647.647 0 1 0 1.293 0zm0 0",
    className: "cls-1",
    transform: "translate(-195.082)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    id: "Path_1906",
    d: "M273.5 43.556v-2.91a.647.647 0 1 0-1.293 0v2.91a.647.647 0 1 0 1.293 0zm0 0",
    className: "cls-1",
    transform: "translate(-250.233 -36.767)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    id: "Path_1907",
    d: "M153.5 43.556v-2.91a.647.647 0 1 0-1.293 0v2.91a.647.647 0 1 0 1.293 0zm0 0",
    className: "cls-1",
    transform: "translate(-139.931 -36.767)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandDollar);
export default __webpack_public_path__ + "static/media/HandDollar.dbba35671d2fbfff5682d2df717d4c9c.svg";
export { ForwardRef as ReactComponent };